var $9391f6f82598ed73$exports = {};
(function() {
    const formModal = document.querySelector('.form-modal');
    const successModal = document.querySelector('.success-modal');
    const demoForm = document.querySelector('.demo-form');
    const inputs = demoForm.querySelectorAll('input:not([type=hidden]');
    const submitButton = demoForm.querySelector('.submit-btn');
    const errorMessage = demoForm.querySelector('.error-message');
    const api = 'https://nn.int.uxfb.dev/webhook/uxfb/expo';
    const validationRules = {
        name: /.{2,}/g,
        company: /.{2,}/g,
        post: /.{2,}/g,
        telegram: /.{2,}/g
    };
    const isInputValid = (input)=>{
        const rule = validationRules[input.name];
        return input.value.match(rule);
    };
    const validateForm = ()=>{
        let isFormValid = true;
        inputs.forEach((item)=>{
            const isValid = isInputValid(item);
            item.parentElement.classList.toggle('error', !isValid);
            if (!isValid) isFormValid = false;
        });
        errorMessage.classList.toggle('showErrorMessage', !isFormValid);
        return isFormValid;
    };
    submitButton.addEventListener("click", function() {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const isValidateForm = validateForm();
        let dataObject = {
            name: null,
            company: null,
            post: null,
            telegram: null,
            urlUtm: `${new URL(document.location.href)}`,
            expoDate: `${day}-${month}-${year}`
        };
        if (isValidateForm) {
            inputs.forEach((input)=>{
                dataObject[input.name] = input.value;
            });
            Object.keys(dataObject).forEach((key)=>{
                dataObject[key] = dataObject[key]?.replaceAll('>', '&#62;').replaceAll('<', '&#60;').replaceAll('&', '&#38;').replaceAll(/eval/gi, '&#101;&#118;&#97;&#108;');
            });
            fetch(api, {
                method: 'post',
                body: JSON.stringify(dataObject),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(()=>{
                successModal.style.display = 'flex';
                formModal.style.display = 'none';
                ym(49633516, 'reachGoal', document.location.host === 'uxfeedback.ru' ? 'add_research_expo_leads' : 'test_add_research_expo_leads');
            });
        } else inputs.forEach(function(input) {
            input.addEventListener('input', function() {
                validateForm();
            });
        });
    });
})();


//# sourceMappingURL=exhibitionStand.790d223a.js.map
